"use client";

import dynamic from "next/dynamic";
import type { SerializedEditorState } from "lexical";

const Editor = dynamic(() => import("@/components/editor/editor").then((m) => m.Editor), { ssr: false });

export function NewsContent({ content }: { content: string }) {
  let parsed: SerializedEditorState | undefined;
  try {
    const json = JSON.parse(content);
    if (json?.root) parsed = json as SerializedEditorState;
  } catch {}

  if (parsed) return <Editor readOnly editorSerializedState={parsed} />;
  return <p className="text-sm whitespace-pre-wrap">{content}</p>;
}
